import FormField from "@/components/forms/FormField";
import { Input } from "@/components/ui/input";

/**
 * A whole-dollar amount: FormField with "$" in front and "CAD" after, so
 * nobody wonders whether 5000 means dollars, cents or minutes.
 */
export default function MoneyField({ name, id, value, onChange, error, placeholder = "5000", ...fieldProps }) {
  const fieldId = id || name;
  return (
    <FormField name={name} id={fieldId} error={error} {...fieldProps}>
      <div className="relative">
        <span className="pointer-events-none absolute inset-y-0 left-4 flex items-center text-base text-muted-foreground" aria-hidden="true">$</span>
        <Input
          id={fieldId}
          name={name}
          type="number"
          min="0"
          step="1"
          inputMode="numeric"
          placeholder={placeholder}
          value={value || ""}
          onChange={onChange}
          aria-invalid={!!error}
          className={`pl-8 pr-14 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${error ? "border-destructive focus-visible:ring-destructive" : ""}`}
        />
        <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-xs font-medium text-muted-foreground" aria-hidden="true">CAD</span>
      </div>
    </FormField>
  );
}
